import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}

/**
 * Return up to 2 uppercase initials from a person's name.
 * Falls back to "?" when name is empty or undefined.
 */
export function getInitials(name?: string): string {
  if (!name) return "?";
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

// Authentication is handled by Convex Auth using email verification and OAuth
// No client-side auth utilities needed
